import type { TFunction } from 'i18next';

import yup from '../../../shared/validation';

export function getTrainingFormValidation(t: TFunction) {
  return yup.object({
    title: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.nameRequired')),

    startDate: yup
      .date()
      .typeError(t('formikValidation.invalidDate'))
      .test(
        'start-before-finish',
        t('formikValidation.startBeforeFinish'),
        function (value) {
          const { finishDate } = this.parent;
          if (!value || !finishDate) return true;
          return value <= finishDate;
        },
      ),

    finishDate: yup
      .date()
      .typeError(t('formikValidation.invalidDate'))
      .test(
        'finish-after-start',
        t('formikValidation.finishAfterStart'),
        function (value) {
          const { startDate } = this.parent;
          if (!value || !startDate) return true;
          return value >= startDate;
        },
      ),
  });
}
